import { WhitelabelTestTheme as WhitelabelTestMFTheme } from '@famly/mf_theme';
import { hexToRGBA } from 'web-app/util/hex-to-rgb';
import BaseTheme from './base';
const WhitelabelTestChromeColor = '#0F766E';
const WhitelabelTestPrimary = WhitelabelTestChromeColor;
const WhitelabelTestActive = hexToRGBA(WhitelabelTestChromeColor, 0.8);
const WhitelabelTestBackgroundHover = hexToRGBA(WhitelabelTestChromeColor, 0.04);
const WhitelabelTestTheme = {
    ...BaseTheme,
    title: 'Whitelabel Test',
    chromeColor: WhitelabelTestChromeColor,
    primary: WhitelabelTestPrimary,
    active: WhitelabelTestActive,
    backgroundHover: WhitelabelTestBackgroundHover,
    mf: WhitelabelTestMFTheme,
};
export default WhitelabelTestTheme;
